export default "loading8b4fd23788e66472.svg"